import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import { selectAlertDialogAcceptHandler, selectAlertDialogCancelHandler } from './alertDialog.selectors';

/**
 * Thunk used to call the confirmation handler of the alert dialog with arguments.
 */
export const runAcceptHandler = createFOAsyncThunk(
  'alertDialog/runAcceptHandler',
  async (args, thunkApi) => {
    const acceptHandler = selectAlertDialogAcceptHandler(thunkApi.getState());
    if (typeof acceptHandler?.func === 'function') {
      await acceptHandler.func(acceptHandler.args);
    }
  },
  {
    showApplicationLoading: true,
  },
);

/**
 * Thunk used to call the cancel handler of the alert dialog with arguments.
 */
export const runCancelHandler = createFOAsyncThunk(
  'alertDialog/runCancelHandler',
  async (args, thunkApi) => {
    const cancelHandler = selectAlertDialogCancelHandler(thunkApi.getState());
    if (typeof cancelHandler?.func === 'function') {
      await cancelHandler.func(cancelHandler.args);
    }
  },
  {
    showApplicationLoading: true,
  },
);
